<template>
    <div class="demo-box">
        <el-upload
                class="avatar-uploader"
                :action="actionUri"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-progress="handleProgress"
                :on-error="handleError"
                :before-upload="beforeUpload"
                :data="{responseType: 'json'}"
                :file-list="uploadFileList"
                :name="type"
                v-if="editable"
        >
            <img v-if="uploadImage" :src="uploadImage" class="avatar">
            <img v-else-if="fileTypeUrl" :src="fileTypeUrl" class="avatar">
            <img v-else :src="require('../assets/images/novideo.png')" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div v-else>
            <img v-if="uploadImage" :src="uploadImage" class="avatar">
            <img v-else-if="fileTypeUrl" :src="fileTypeUrl" class="avatar">
            <img v-else :src="require('../assets/images/novideo.png')" />
        </div>
        <div><a href="#" @click.prevent="handleDownload" v-if="value">[下载]</a></div>
    </div>
</template>

<script>
  import Constant from '../utils/constant'
  import {getFileUrl, getImageUrl} from "../filters/CommonActions";
  import { Loading } from 'element-ui';
  import { Message } from 'element-ui';

  let loadingInstance = {}

  export default {
    name: "FileUpload",
    data() {
      return {
        uploadFileList: [],
        uploadImage: '',
        dialogVisible: false,
      }
    },
    props: {
      field: String,
      value: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'file'
      },
      prefix: {
        type: String,
        default: ''
      },
      editable: {
        Boolean,
        default: true
      }
    },
    computed: {
      actionUri: function () {
        return Constant.SERVER_BASE_URL + '/u' + this.type + '/scf.upload'
      },
      fileTypeUrl: function () {
        return this.value && require('../assets/images/video.png')
      }
    },
    methods: {
      handleSuccess(res, file) {
        loadingInstance.close()
        Message.success('文件上传成功！')
        let fileItem = res.files[0]
        this.uploadImage = require('../assets/images/video.png');
        this.$emit('input', fileItem.fileId)
      },
      handleError(err, file, fileList) {
        Message.error('文件上传失败！')

        loadingInstance.close()
      },
      handleProgress(event, file, fileList) {
      },
      beforeUpload(file) {
        const isPDF = file.type === 'application/pdf';
        const isLt40M = file.size / 1024 / 1024 < 100;

        if (!isPDF) {
          this.$message.error('上传图片只能是 PDF 格式 !');
        }
        if (!isLt40M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }

        const ret = (isPDF) && isLt40M

        if(ret) {
          loadingInstance = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
        }

        return ret
      },
      handleDownload() {
        window.open(getFileUrl(this.value))
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/VideoUpload.vue